import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    {/* Columna 1: Marca y Contacto */}
                    <div className="footer-brand">
                        <div className="footer-logo">
                            <img src="/assets/logo-sin-fondo.webp" alt="NAVI" style={{ height: '44px', opacity: 0.9 }} />
                        </div>
                        <p className="footer-desc">
                            Soluciones de inteligencia artificial que transforman procesos reales — accesibles, prácticas y diseñadas para crecer contigo.
                        </p>
                        <div className="footer-contact-info">
                            <p>Alcoy (Alicante), España</p>
                            <p>contacto@navitechlabs.com</p>
                            <p>+34 604 99 12 24</p>
                        </div>
                    </div>

                    {/* Columna 2: Navegación */}
                    <div>
                        <div className="f-title">Navegación</div>
                        <div className="f-links">
                            <a href="/#inicio" className="f-link">Inicio</a>
                            <a href="/#servicios" className="f-link">Servicios</a>
                            <a href="/#nosotros" className="f-link">Nosotros</a>
                            <a href="/blog" className="f-link">Blog</a>
                        </div>
                    </div>

                    {/* Columna 3: Portfolio y Demos */}
                    <div>
                        <div className="f-title">Portfolio</div>
                        <div className="f-links">
                            <Link to="/portfolio/mantenimiento-predictivo" className="f-link">Mantenimiento predictivo</Link>
                            <Link to="/portfolio/orquestador-multi-agente" className="f-link">Orquestador multi-agente</Link>
                            <Link to="/portfolio/cerebro-documental" className="f-link">Cerebro documental</Link>
                            <Link to="/demos/inmobiliarias" className="f-link">Demo Inmobiliarias</Link>
                        </div>
                    </div>

                    {/* Columna 4: Legal */}
                    <div>
                        <div className="f-title">Legal</div>
                        <div className="f-links">
                            <Link to="/politicadeprivacidad" className="f-link" target="_blank" rel="noopener noreferrer">Política de Privacidad</Link>
                            <Link to="/cookies" className="f-link" target="_blank" rel="noopener noreferrer">Cookies</Link>
                            <Link to="/avisolegal" className="f-link" target="_blank" rel="noopener noreferrer">Aviso Legal</Link>
                            <Link to="/terminosycondiciones" className="f-link" target="_blank" rel="noopener noreferrer">Términos y Condiciones</Link>
                            <Link to="/clausulasdeconsentimiento" className="f-link" target="_blank" rel="noopener noreferrer">Cláusulas de Consentimiento</Link>
                        </div>
                    </div>
                </div>

                {/* Sección inferior: Copyright y Redes */}
                <div className="footer-btm">
                    <span className="f-copy">© {new Date().getFullYear()} NaviTech Labs · Todos los derechos reservados.</span>
                    <div className="f-socials">
                        <a href="https://www.linkedin.com/company/navi-ol/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="f-soc" aria-label="LinkedIn">
                            LinkedIn
                        </a>
                        <a href="https://www.instagram.com/naviaisolutions?igsh=NTVvdHFyM2oyeHo=" target="_blank" rel="noopener noreferrer" className="f-soc" aria-label="Instagram">
                            Instagram
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;